export const paymentsMethodConstants = {
  CREATE_PAYMENTSMETHOD: 'CREATE_PAYMENTSMETHOD',
  RETRIEVE_PAYMENTSMETHOD: 'RETRIEVE_PAYMENTSMETHOD',
  UPDATE_PAYMENTSMETHOD: 'UPDATE_PAYMENTSMETHOD',
  DELETE_PAYMENTSMETHOD: 'DELETE_PAYMENTSMETHOD',
  DELETE_ALL_PAYMENTSMETHOD: 'DELETE_ALL_PAYMENTSMETHOD',
}
